// extracted by mini-css-extract-plugin
module.exports = {"root":"_20fe97","disabled":"_563454"};